import type { FaireProductEntity } from "../../entity_types/product";

export const p_33t7m2w3q6: FaireProductEntity = {
  token: "p_33t7m2w3q6",
  type: "product",
  name: "Apple a Day Set of Two Stitched Notebooks Journals",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/758791e2d4fa18cda9f4db0f435d44b689ba6563ea00b991dece91ec69ff0572.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/547ff358722926f352390eb20473217e0fdd775ae4786cb8f701b43baf5b57e9.jpeg",
    "https://cdn.faire.com/fastly/bcafcc736f0a2c97c8579fa0585fc56502317f8acdf5d1c219b3851a9c128e7c.jpeg",
    "https://cdn.faire.com/fastly/890c64d9340b2db1323203b842e7533bf27b03cf9a8eb69ed23ab6d811514ec2.jpeg",
    "https://cdn.faire.com/fastly/ed8564beca69e39d963d45996e84dbe41b0a2571737c2ce7418b6d8316f5f2f9.jpeg",
  ],
  priceDollars: 8,
  description:
    "Who among us does not have an entire ocean of thoughts floating around in our heads? Nobody! A notebook is the perfect way to calm the cranial seas... simply write things down. And this set of 2 gives you so many options - make one messy, one clean. One to remember, one to forget. Likes, dislikes. Business in the front, party in the back. Have fun seeing what your thought waves will come up with.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:36.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
